import { render, staticRenderFns } from "./viewCustomerDetails.vue?vue&type=template&id=4608131c&"
import script from "./viewCustomerDetails.vue?vue&type=script&lang=js&"
export * from "./viewCustomerDetails.vue?vue&type=script&lang=js&"
import style0 from "./viewCustomerDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports